import React, { useState, useEffect } from 'react'
import { useStore } from 'app/store'
import { observer } from 'mobx-react'
import { displayString } from 'app/helpers'
import { NavLink } from 'react-router-dom'
import Error from '@mui/icons-material/Error'
import MatxTooltip from '../MatxTooltip/MatxTooltip'

const FolderName = ({ objectType, objectId, hyperlink = false }) => {
  const { folders } = useStore()
  const [errored, setErrored] = useState(false)
  const [loading, setLoading] = useState(true)
  const folder = folders.foldersInfoEnteries[objectType]?.[objectId]

  const loadData = async () => {
    setLoading(true)
    setErrored(false)
    try {
      await folders.getFolderInfo(objectType, objectId)
    } catch (error) {
      setErrored(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return <span>Loading...</span>
  }
  if (errored) {
    return (
      <MatxTooltip title="Failed to load, Click to retry">
        <span onClick={loadData}>
          <Error
            style={{ marginBottom: '-1.7px' }}
            onClick={loadData}
            fontSize={'inherit'}
            color={'error'}
          />
        </span>
      </MatxTooltip>
    )
  }
  if (folder?.name && hyperlink) {
    return (
      <NavLink className="text-info" to={`/folders/${folder.id}`}>
        {folder?.name}
      </NavLink>
    )
  }
  return <span>{displayString(folder?.name)}</span>
}

export default observer(FolderName)
